var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.87384C0 5.73478 0.925189 4.81192 2.06192 4.81192H4.16801C4.5074 2.09911 6.8227 0 9.62616 0C12.4296 0 14.7449 2.10144 15.0843 4.81192H17.1904C18.3295 4.81192 19.2523 5.73711 19.2523 6.87384V21.3119C19.2523 21.6908 18.9432 22 18.5642 22H0.688081C0.309171 22 0 21.6908 0 21.3119V6.87384ZM2.06424 6.18576C1.68533 6.18576 1.37616 6.49493 1.37616 6.87384V20.6238H6.18808V14.4358C6.18808 13.2967 7.11095 12.3738 8.25 12.3738H11C12.1391 12.3738 13.0619 13.299 13.0619 14.4358V20.6238H17.8738V6.87384C17.8738 6.49493 17.5647 6.18576 17.1858 6.18576H15.0797C14.7403 8.89856 12.425 10.9977 9.62151 10.9977C6.81805 10.9977 4.50275 8.89624 4.16336 6.18576H2.05727H2.06424ZM13.7523 5.49768C13.7523 3.22189 11.9043 1.37151 9.62616 1.37151C7.34806 1.37151 5.5 3.21957 5.5 5.49768C5.5 7.77578 7.34806 9.62384 9.62616 9.62384C11.9043 9.62384 13.7523 7.77578 13.7523 5.49768ZM7.56424 20.6215H11.6904V14.4334C11.6904 14.0545 11.3812 13.7454 11.0023 13.7454H8.25233C7.87342 13.7454 7.56424 14.0545 7.56424 14.4334V20.6215Z",
    fill: "#FF669B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/Clinic.2a5d5b19bc628fae844a110549bb741c.svg";
export { ForwardRef as ReactComponent };